export default function getCategories(locations) {
  const categories = new Set(); // Using a Set to store unique values

  locations.forEach((doc) => {
    (doc.properties?.categories || []).forEach((category) =>
      categories.add(category)
    );
  });

  // Convert the Set to an array and sort alphabetically
  return Array.from(categories).sort((a, b) => a.localeCompare(b));
}
